import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Paper, Radio } from '@mui/material';
import { Link } from 'react-router-dom';
import RenderIf from '../renderIf';
import DateTimeText from '../shared/DateTimeText';

const ActionDrivenTable = ({ columns, data, rowSelectionHandler, selectedItem, dataKey }) => {
    const getTermDescription = (rowData, colID) => {
        const terms = rowData[colID];
        if (!terms.length) {
            return '';
        } else if (!!terms.length && terms.length > 1) {
            return terms.join('\n');
        } else {
            return terms[0];
        }
    };
    const getMultiLineValue = (values) => {
        return values?.map((value) => <Typography>{value}</Typography>);
    };

    // TODO Once the Record component has been refactored the 'to' property of the viewApplication Link will need to be updated to reflect that (no more need for ?admin)
    const getValue = (row, columnId) => {
        switch (columnId) {
            case 'Terms Description':
                return getTermDescription(row, columnId);
            case 'viewApplication':
                return (
                    <Link
                        style={{ color: '#494FF9' }}
                        to={`/scholarship/application/${row.AppInstID}?admin`}
                    >
                        View
                    </Link>
                );
            case 'Students':
            case 'UniqueIDs':
                return getMultiLineValue(row[columnId]);
            case 'Created Date':
            case 'CreatedUTC':
            case 'Submitted':
            case 'DOB':
                return (
                    <Typography>
                        {!!row[columnId] ? (
                            <DateTimeText
                                date={row[columnId]}
                                type="short"
                            />
                        ) : (
                            '--'
                        )}
                    </Typography>
                );
            default:
                return row[columnId];
        }
    };
    const handleRadioChange = (rowData) => {
        if (rowSelectionHandler) {
            rowSelectionHandler(rowData);
        }
    };
    const isChecked = (currentRow) => {
        if (selectedItem) {
            return selectedItem[dataKey] === currentRow[dataKey];
        } else return false;
    };
    const getBackgroundColor = (rowData) => {
        if (rowSelectionHandler) {
            if (isChecked(rowData)) return '#F9FBFF';
            else return 'initial';
        } else return '#F9FBFF';
    };
    return (
        <TableContainer component={Paper}>
            <Table aria-label="generic table">
                <TableHead>
                    <TableRow>
                        <RenderIf isTrue={rowSelectionHandler}>
                            <TableCell />
                        </RenderIf>
                        {columns?.map((column) => {
                            return <TableCell key={column.id}>{column.label}</TableCell>;
                        })}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data?.map((row, index) => (
                        <TableRow
                            key={index}
                            style={{ backgroundColor: getBackgroundColor(row) }}
                        >
                            <RenderIf isTrue={rowSelectionHandler}>
                                <TableCell>
                                    <Radio
                                        value={index}
                                        onChange={() => handleRadioChange(row)}
                                        checked={isChecked(row)}
                                        style={{ color: isChecked(row) ? '#494FF9' : '#586874' }}
                                    />
                                </TableCell>
                            </RenderIf>
                            {columns?.map((column) => (
                                <TableCell key={column.id}>{getValue(row, column.id)}</TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default ActionDrivenTable;
